export const createResource = (params, body) => {
  return {
    data: {
      resource: {
        id: Math.floor(Math.random() * 200) + 1,
        name: body.name,
        link: body.link,
      },
    },
    status: 200,
  };
};

export const updateResource = (params, body) => {
  return {
    data: {
      resource: {
        id: params.pk,
        name: body.name,
        link: body.link,
      },
    },
    status: 200,
  };
};
